import Repository from "./repository";
const update = "/users/update-email";

export default {
  updateEmail(payload) {
    return Repository.put(`${update}`, payload);
  },
};
